<template>

  <svg
    t="1640065966638"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4436"
    width="64"
    height="64"
  ><path d="M512 90.125a225 225 0 0 1 225 225 28.125 28.125 0 0 1-56.25 0 168.75 168.75 0 0 0-337.3875-6.328125L343.25 315.125v112.5h450a56.25 56.25 0 0 1 56.25 56.25v365.625a56.25 56.25 0 0 1-56.25 56.25H230.75a56.25 56.25 0 0 1-56.25-56.25V483.875a56.25 56.25 0 0 1 56.25-56.25h56.25V315.125a225 225 0 0 1 225-225z m281.25 393.75H230.75v365.625h562.5V483.875z m-281.25 84.375a56.25 56.25 0 0 1 28.153125 104.9625L540.125 737a28.125 28.125 0 0 1-56.25 0v-63.7875A56.25 56.25 0 0 1 512 568.25z" p-id="4437" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconUnlock',
} as DefineComponent
</script>